import { forwardRef, HTMLAttributes } from "react";
import { cn } from "@/src/lib/utils";

interface SectionProps extends HTMLAttributes<HTMLElement> {}

const Section = forwardRef<HTMLElement, SectionProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <section ref={ref} className={cn("py-16 md:py-24", className)} {...props}>
        {children}
      </section>
    );
  },
);

Section.displayName = "Section";

export default Section;